import api from "api/axios";

export interface PipelineCounts {
  linkedin_alerts: number;
  theirstack_jobs: number;
  watchlist_leads: number;
}

export interface StatusCounts {
  [status: string]: number;
}

export interface PipelineStatusBreakdown {
  linkedin_alerts: StatusCounts;
  theirstack_jobs: StatusCounts;
  watchlist_leads: StatusCounts;
}

export interface TmLeaderboardRow {
  employee_id: number;
  employee_code: string;
  name: string;
  applied: number;
  archived: number;
  tracked: number;
  last_activity_at: string | null;
}

export interface AdminDashboardStats {
  today: PipelineCounts;
  status_funnel: PipelineStatusBreakdown;
  stale_new_org_wide: PipelineCounts;
  unassigned_hiring: { companies: number; contacts: number };
  companies_naics_pending?: number; // CRM companies with NAICS suggestions waiting for approval
  companies_office_not_located?: number; // CRM companies with a US office that could not be placed on the map
  companies_missing_address: number; // CRM companies with no office that has a street address
  stale_new_days_org: number;
  inactive_tm_count: number;
  inactive_tm_days: number;
  silent_pipelines: PipelineFlags;
  silent_pipeline_days: number;
}

export interface PipelineFlags {
  linkedin_alerts: boolean;
  theirstack_jobs: boolean;
  watchlist_leads: boolean;
}

export type DashboardRange = "today" | "7d" | "30d" | "90d" | "6m" | "1y";

export const RANGE_OPTIONS: { value: DashboardRange; label: string }[] = [
  { value: "today", label: "Today" },
  { value: "7d", label: "Last 7 Days" },
  { value: "30d", label: "Last 30 Days" },
  { value: "90d", label: "Last 90 Days" },
  { value: "6m", label: "Last 6 Months" },
  { value: "1y", label: "Last 1 Year" },
];

export interface EmployeeDashboardStats {
  today: PipelineCounts;
  status_breakdown: PipelineStatusBreakdown;
  hiring_contacts: { companies: StatusCounts; contacts: StatusCounts };
  stale_new_count: number;
  stale_new_days: number;
  hot_lead_stale_count: number;
  hot_lead_stale_days: number;
  stale_hiring_contacts_count: number;
  stale_hiring_contacts_days: number;
}

export async function getAdminDashboardStats(): Promise<AdminDashboardStats> {
  const res = await api.get("/admin/dashboard/stats");
  return res.data;
}

export async function getTmLeaderboard(range: DashboardRange): Promise<TmLeaderboardRow[]> {
  const res = await api.get("/admin/dashboard/tm-leaderboard", { params: { range } });
  return res.data;
}

export async function getEmployeeDashboardStats(): Promise<EmployeeDashboardStats> {
  const res = await api.get("/employee/dashboard/stats");
  return res.data;
}
